import React from 'react';
import { Star } from 'lucide-react';

/**
 * Reviews block. If no reviews yet, shows an empty-state with a "write review" invite.
 *
 * Props:
 *   rating: number 0..5 (average)
 *   count: number
 *   productName: string
 */
export default function ReviewsBlock({ rating = 0, count = 0, productName = '' }) {
  const full = Math.floor(rating);
  const half = rating - full >= 0.5;
  return (
    <div className="mt-8 pt-6 border-t border-gray-200" data-testid="reviews-block">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-sm font-bold uppercase tracking-widest text-[#334155]">Reviews</h3>
        <button
          className="text-xs font-semibold text-[#334155] hover:underline"
          data-testid="reviews-write"
        >
          Write a review
        </button>
      </div>
      <div className="flex items-center gap-3">
        <div className="flex">
          {[0, 1, 2, 3, 4].map((i) => (
            <Star
              key={i}
              className={`w-5 h-5 ${
                i < full
                  ? 'fill-[#D4A55A] text-[#D4A55A]'
                  : i === full && half
                  ? 'fill-[#D4A55A]/50 text-[#D4A55A]'
                  : 'fill-gray-200 text-gray-200'
              }`}
            />
          ))}
        </div>
        {count > 0 ? (
          <p className="text-sm text-gray-600">
            <span className="font-semibold text-gray-900">{rating.toFixed(1)}</span> · {count}{' '}
            review{count === 1 ? '' : 's'}
          </p>
        ) : (
          <p className="text-sm text-gray-500">
            Be the first to review{productName ? ` the ${productName}` : ''}.
          </p>
        )}
      </div>
    </div>
  );
}
